<div class="kiosk-wrapper">
  <!-- Animated background particles -->
  <div class="particles-bg">
    <div
      *ngFor="let p of particles"
      class="particle"
      [ngStyle]="getParticleStyle(p)">
    </div>
  </div>

  <!-- Exit button (hidden corner) -->
  <button class="exit-trigger" (click)="openExitDialog()"></button>

  <!-- Sound toggle -->
  <button class="sound-toggle" (click)="toggleSound()">
    {{ soundEnabled ? '🔊' : '🔇' }}
  </button>

  <!-- ═══ MAIN MENU ═══ -->
  <div class="menu-screen" *ngIf="activeGame === 'menu'">
    <div class="menu-header">
      <div class="header-logo">
        <img [src]="clientLogo" [alt]="clientName" class="logo-img">
      </div>
      <h1>{{ clientName }} <span class="accent">Arcade</span></h1>
      <p class="subtitle">{{ clientSubtitle }}</p>
    </div>

    <div class="game-grid">
      <div
        *ngFor="let game of gameList"
        class="game-card"
        (click)="selectGame(game.id)"
        [style.--card-color]="game.color">
        <div class="card-glow"></div>
        <div class="card-icon">{{ game.icon }}</div>
        <h3>{{ game.title }}</h3>
        <p>{{ game.desc }}</p>
        <div class="card-best" *ngIf="getBestForGame(game.id)">
          <span>🏆 {{ getBestForGame(game.id) }}</span>
        </div>
        <div class="card-badge">{{ game.badge }}</div>
      </div>
    </div>

    <!-- Leaderboard Button -->
    <button class="leaderboard-btn" (click)="openLeaderboard()">
      <span class="lb-icon">🏆</span>
      <span>Hall of Fame</span>
    </button>
  </div>

  <!-- ═══ LEADERBOARD OVERLAY ═══ -->
  <div class="leaderboard-overlay" *ngIf="showLeaderboard" (click)="closeLeaderboard()">
    <div class="leaderboard-panel" (click)="$event.stopPropagation()">
      <div class="lb-header">
        <h2>🏆 Hall of Fame</h2>
        <button class="lb-close" (click)="closeLeaderboard()">✕</button>
      </div>

      <!-- Game filter tabs -->
      <div class="lb-tabs">
        <button
          class="lb-tab"
          [class.active]="leaderboardGameFilter === 'all'"
          (click)="filterLeaderboard('all')">
          Todos
        </button>
        <button
          *ngFor="let game of gameList"
          class="lb-tab"
          [class.active]="leaderboardGameFilter === game.id"
          (click)="filterLeaderboard(game.id)">
          {{ game.icon }}
        </button>
      </div>

      <!-- Entries -->
      <div class="lb-content">
        <!-- Grouped by game (all view) -->
        <ng-container *ngIf="leaderboardGameFilter === 'all'">
          <div class="lb-game-group" *ngFor="let game of gameList">
            <div class="lb-game-title">
              <span class="lb-game-icon">{{ game.icon }}</span>
              <span>{{ game.title }}</span>
            </div>
            <div class="lb-entries">
              <div
                class="lb-entry"
                *ngFor="let entry of leaderboard.getTopScores(game.id, 3); let i = index"
                [class.lb-gold]="i === 0"
                [class.lb-silver]="i === 1"
                [class.lb-bronze]="i === 2">
                <span class="lb-rank">{{ i === 0 ? '🥇' : i === 1 ? '🥈' : '🥉' }}</span>
                <span class="lb-name">{{ entry.playerName || 'Anónimo' }}</span>
                <span class="lb-score">{{ leaderboard.formatScore(entry.gameId, entry.score) }}</span>
              </div>
              <div class="lb-empty" *ngIf="leaderboard.getTopScores(game.id, 3).length === 0">
                Sin récords aún
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Single game view -->
        <ng-container *ngIf="leaderboardGameFilter !== 'all'">
          <div class="lb-single-header">
            <span class="lb-single-icon">{{ getGameIcon(leaderboardGameFilter) }}</span>
            <h3>{{ getGameTitle(leaderboardGameFilter) }}</h3>
          </div>
          <div class="lb-entries lb-entries-full">
            <div
              class="lb-entry"
              *ngFor="let entry of leaderboardEntries; let i = index"
              [class.lb-gold]="i === 0"
              [class.lb-silver]="i === 1"
              [class.lb-bronze]="i === 2">
              <span class="lb-rank">
                {{ i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : '#' + (i + 1) }}
              </span>
              <div class="lb-entry-info">
                <span class="lb-name">{{ entry.playerName || 'Anónimo' }}</span>
                <span class="lb-date">{{ entry.date | date:'dd/MM/yy' }}</span>
              </div>
              <span class="lb-score">{{ leaderboard.formatScore(entry.gameId, entry.score) }}</span>
            </div>
            <div class="lb-empty" *ngIf="leaderboardEntries.length === 0">
              Sin récords aún. ¡Sé el primero!
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- ═══ MEMORY GAME ═══ -->
  <div class="game-view" *ngIf="activeGame === 'memory'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>🧠 Memory Match</h2>
      <div class="game-stats-bar">
        <span class="stat"><strong>{{ memoryMoves }}</strong> movs</span>
        <span class="stat"><strong>{{ memoryMatches }}</strong>/8</span>
        <span class="stat">⏱ {{ formatTime(memoryTime) }}</span>
      </div>
    </div>

    <div class="memory-board" [class.completed]="memoryCompleted">
      <div
        *ngFor="let card of memoryCards; let i = index"
        class="memory-card"
        [class.flipped]="card.flipped || card.matched"
        [class.matched]="card.matched"
        (click)="flipCard(card)">
        <div class="card-inner">
          <div class="card-front">
            <img [src]="clientLogo" [alt]="clientName" class="card-front-logo">
          </div>
          <div class="card-back">
            <span class="card-emoji">{{ card.icon }}</span>
            <span class="card-label">{{ card.label }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="victory-overlay" *ngIf="memoryCompleted">
      <div class="victory-card">
        <div class="victory-icon">🎉</div>
        <h3>¡Completado!</h3>
        <p>{{ memoryMoves }} movimientos en {{ formatTime(memoryTime) }}</p>
        <button class="btn-play-again" (click)="initMemory()">Jugar de nuevo</button>
        <button class="btn-back-menu" (click)="backToMenu()">Volver al menú</button>
      </div>
    </div>
  </div>

  <!-- ═══ SLIDING PUZZLE ═══ -->
  <div class="game-view" *ngIf="activeGame === 'puzzle'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>🧩 Slide Puzzle</h2>
      <div class="game-stats-bar">
        <span class="stat"><strong>{{ puzzleMoves }}</strong> movs</span>
        <span class="stat">⏱ {{ formatTime(puzzleTime) }}</span>
      </div>
    </div>

    <div class="puzzle-board" [class.completed]="puzzleCompleted">
      <div
        *ngFor="let tile of puzzleTiles; let i = index"
        class="puzzle-tile"
        [class.empty]="tile.isEmpty"
        [class.correct]="!tile.isEmpty && tile.value === i + 1"
        (click)="moveTile(i)">
        <span *ngIf="!tile.isEmpty">{{ tile.value }}</span>
      </div>
    </div>

    <div class="puzzle-hint">
      <p>Toca una ficha adyacente al espacio vacío para moverla</p>
    </div>

    <div class="victory-overlay" *ngIf="puzzleCompleted">
      <div class="victory-card">
        <div class="victory-icon">🏆</div>
        <h3>¡Puzzle resuelto!</h3>
        <p>{{ puzzleMoves }} movimientos en {{ formatTime(puzzleTime) }}</p>
        <button class="btn-play-again" (click)="initPuzzle()">Jugar de nuevo</button>
        <button class="btn-back-menu" (click)="backToMenu()">Volver al menú</button>
      </div>
    </div>
  </div>

  <!-- ═══ REACTION GAME ═══ -->
  <div class="game-view" *ngIf="activeGame === 'reaction'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>⚡ Reaction Time</h2>
      <div class="game-stats-bar">
        <span class="stat" *ngIf="reactionBest">🏆 <strong>{{ reactionBest }}</strong>ms</span>
        <span class="stat" *ngIf="reactionAttempts.length">Prom: <strong>{{ getReactionAverage() }}</strong>ms</span>
      </div>
    </div>

    <div class="reaction-area"
         [class.waiting]="reactionState === 'waiting'"
         [class.ready]="reactionState === 'ready'"
         [class.too-early]="reactionState === 'too-early'"
         [class.clicked]="reactionState === 'clicked'"
         (click)="reactionState === 'idle' || reactionState === 'too-early' || reactionState === 'clicked' ? startReaction() : clickReaction()">

      <div class="reaction-content" *ngIf="reactionState === 'idle'">
        <div class="reaction-icon">🎯</div>
        <h3>Prueba tus reflejos</h3>
        <p>Toca para comenzar</p>
      </div>

      <div class="reaction-content" *ngIf="reactionState === 'waiting'">
        <div class="reaction-icon pulse">🔴</div>
        <h3>Espera el verde...</h3>
        <p>No toques aún</p>
      </div>

      <div class="reaction-content reaction-go" *ngIf="reactionState === 'ready'">
        <div class="reaction-go-flash"></div>
        <div class="reaction-icon go-bounce">🟢</div>
        <h3 class="go-text">¡AHORA!</h3>
        <p class="go-sub">¡TOCA YA!</p>
      </div>

      <div class="reaction-content" *ngIf="reactionState === 'too-early'">
        <div class="reaction-icon">😅</div>
        <h3>¡Muy pronto!</h3>
        <p>Toca para intentar de nuevo</p>
      </div>

      <div class="reaction-content" *ngIf="reactionState === 'clicked'">
        <div class="reaction-icon">⚡</div>
        <h3>{{ reactionTime }}ms</h3>
        <p class="reaction-rating" *ngIf="reactionTime < 200">¡Increíble!</p>
        <p class="reaction-rating" *ngIf="reactionTime >= 200 && reactionTime < 300">¡Muy rápido!</p>
        <p class="reaction-rating" *ngIf="reactionTime >= 300 && reactionTime < 400">Buen reflejo</p>
        <p class="reaction-rating" *ngIf="reactionTime >= 400">Puedes mejorar</p>
        <p class="small">Toca para intentar de nuevo</p>
      </div>
    </div>

    <div class="reaction-history" *ngIf="reactionAttempts.length > 0">
      <div class="attempt" *ngFor="let t of reactionAttempts; let i = index">
        <span class="attempt-num">#{{ i + 1 }}</span>
        <div class="attempt-bar" [style.width.%]="Math.min((t / 600) * 100, 100)"></div>
        <span class="attempt-time">{{ t }}ms</span>
      </div>
    </div>
  </div>

  <!-- ═══ SIMON SAYS ═══ -->
  <div class="game-view" *ngIf="activeGame === 'simon'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>🎵 Simon Says</h2>
      <div class="game-stats-bar">
        <span class="stat">Nivel: <strong>{{ simonLevel }}</strong></span>
        <span class="stat" *ngIf="simonBest">🏆 <strong>{{ simonBest }}</strong></span>
      </div>
    </div>

    <div class="simon-container">
      <div class="simon-status">
        <span *ngIf="simonState === 'idle'">Presiona iniciar para jugar</span>
        <span *ngIf="simonState === 'showing'" class="simon-showing">Observa la secuencia...</span>
        <span *ngIf="simonState === 'player'" class="simon-your-turn">¡Tu turno! ({{ simonPlayerIndex }}/{{ simonSequence.length }})</span>
        <span *ngIf="simonState === 'gameover'" class="simon-over">¡Game Over! Llegaste al nivel {{ simonLevel }}</span>
      </div>

      <div class="simon-board simon-grid-3">
        <button
          *ngFor="let color of simonColors; let i = index"
          class="simon-btn simon-{{ color }}"
          [class.active]="simonActiveColor === i || simonPlayerFlash === i"
          [disabled]="simonState !== 'player'"
          (click)="simonPress(i)">
        </button>
      </div>

      <button
        *ngIf="simonState === 'idle' || simonState === 'gameover'"
        class="btn-play-again simon-start"
        (click)="startSimon()">
        {{ simonState === 'gameover' ? 'Jugar de nuevo' : 'Iniciar' }}
      </button>
    </div>
  </div>

  <!-- ═══ WHACK-A-MOLE ═══ -->
  <div class="game-view" *ngIf="activeGame === 'whack'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>🎯 Atrapa el Logo</h2>
      <div class="game-stats-bar">
        <span class="stat"><strong>{{ whackScore }}</strong> puntos</span>
        <span class="stat" [class.time-warning]="whackTimeLeft <= 5">⏱ <strong>{{ whackTimeLeft }}</strong>s</span>
      </div>
    </div>

    <div class="whack-container">
      <div *ngIf="whackState === 'idle'" class="whack-start-screen">
        <div class="whack-start-icon">
          <img [src]="clientLogo" [alt]="clientName" class="whack-logo-preview">
        </div>
        <h3>¿Listo para atrapar?</h3>
        <p>Tienes {{ whackDuration }} segundos para tocar tantos logos como puedas</p>
        <button class="btn-play-again" (click)="startWhack()">¡A jugar!</button>
      </div>

      <div *ngIf="whackState === 'playing'" class="whack-grid">
        <div
          *ngFor="let active of whackGrid; let i = index"
          class="whack-hole"
          [class.active]="active"
          (click)="whackHit(i)">
          <div class="mole" *ngIf="active">
            <img [src]="clientLogo" [alt]="clientName" class="mole-face">
          </div>
          <div class="hole-base"></div>
        </div>
      </div>

      <div *ngIf="whackState === 'done'" class="victory-overlay-inline">
        <div class="victory-card">
          <div class="victory-icon">🏆</div>
          <h3>¡Tiempo!</h3>
          <p>Atrapaste <strong>{{ whackScore }}</strong> objetivos</p>
          <button class="btn-play-again" (click)="startWhack()">Jugar de nuevo</button>
          <button class="btn-back-menu" (click)="backToMenu()">Volver al menú</button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ SPEED TAP ═══ -->
  <div class="game-view" *ngIf="activeGame === 'speedtap'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>👆 Speed Tap</h2>
      <div class="game-stats-bar">
        <span class="stat"><strong>{{ speedTapScore }}</strong> puntos</span>
        <span class="stat" [class.time-warning]="speedTapTimeLeft <= 5">⏱ <strong>{{ speedTapTimeLeft }}</strong>s</span>
      </div>
    </div>

    <div class="speedtap-container">
      <div *ngIf="speedTapState === 'idle'" class="speedtap-start">
        <div class="speedtap-start-icon">👆</div>
        <h3>Speed Tap</h3>
        <p>Toca los objetivos lo más rápido que puedas. Se achican y desaparecen más rápido.</p>
        <button class="btn-play-again" (click)="startSpeedTap()">¡A jugar!</button>
      </div>

      <div *ngIf="speedTapState === 'playing'" class="speedtap-arena">
        <div
          *ngIf="speedTapTarget"
          class="speedtap-target"
          [style.left.%]="speedTapTarget.x"
          [style.top.%]="speedTapTarget.y"
          [style.width.px]="speedTapTarget.size"
          [style.height.px]="speedTapTarget.size"
          (click)="hitSpeedTap()">
          <img [src]="clientLogo" [alt]="clientName" class="speedtap-logo">
        </div>
      </div>

      <div *ngIf="speedTapState === 'done'" class="victory-overlay-inline">
        <div class="victory-card">
          <div class="victory-icon">⚡</div>
          <h3>¡Tiempo!</h3>
          <p>Tocaste <strong>{{ speedTapScore }}</strong> objetivos</p>
          <button class="btn-play-again" (click)="startSpeedTap()">Jugar de nuevo</button>
          <button class="btn-back-menu" (click)="backToMenu()">Volver al menú</button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ BALLOON POP ═══ -->
  <div class="game-view" *ngIf="activeGame === 'balloonpop'">
    <div class="game-topbar">
      <button class="btn-back" (click)="backToMenu()">← Volver</button>
      <h2>🎈 Balloon Pop</h2>
      <div class="game-stats-bar">
        <span class="stat"><strong>{{ balloonScore }}</strong> pts</span>
        <span class="stat" *ngIf="balloonCombo >= 3" class="combo-badge">x{{ balloonCombo >= 5 ? 3 : 2 }} COMBO</span>
        <span class="stat" [class.time-warning]="balloonTimeLeft <= 5">⏱ <strong>{{ balloonTimeLeft }}</strong>s</span>
      </div>
    </div>

    <div class="balloon-container">
      <div *ngIf="balloonState === 'idle'" class="balloon-start">
        <div class="balloon-start-icon">🎈</div>
        <h3>Balloon Pop</h3>
        <p>Revienta los globos antes de que escapen. ¡Los combos multiplican puntos!</p>
        <div class="balloon-legend">
          <span class="legend-item"><span class="legend-dot" style="background:#ef4444"></span> 1pt</span>
          <span class="legend-item"><span class="legend-dot" style="background:#10b981"></span> 2pt</span>
          <span class="legend-item"><span class="legend-dot" style="background:#ec4899"></span> 3pt</span>
          <span class="legend-item"><span class="legend-dot" style="background:#1400FF"></span> 5pt</span>
        </div>
        <button class="btn-play-again" (click)="startBalloonPop()">¡A jugar!</button>
      </div>

      <div *ngIf="balloonState === 'playing'" class="balloon-arena">
        <div
          *ngFor="let b of balloons; trackBy: trackBalloon"
          class="balloon"
          [class.popped]="b.popped"
          [ngStyle]="getBalloonStyle(b)"
          (click)="popBalloon(b)">
          <div class="balloon-body"></div>
          <div class="balloon-string"></div>
        </div>
      </div>

      <div *ngIf="balloonState === 'done'" class="victory-overlay-inline">
        <div class="victory-card">
          <div class="victory-icon">🎈</div>
          <h3>¡Tiempo!</h3>
          <p><strong>{{ balloonScore }}</strong> puntos</p>
          <p class="small" *ngIf="balloonMaxCombo >= 3">Mejor combo: x{{ balloonMaxCombo >= 5 ? 3 : 2 }}</p>
          <button class="btn-play-again" (click)="startBalloonPop()">Jugar de nuevo</button>
          <button class="btn-back-menu" (click)="backToMenu()">Volver al menú</button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ RECORD CELEBRATION OVERLAY ═══ -->
  <div class="record-overlay" *ngIf="showRecordOverlay">
    <!-- Confetti -->
    <div class="confetti-layer" *ngIf="recordStep === 'celebrate'">
      <div
        *ngFor="let c of confettiPieces"
        class="confetti-piece"
        [style.left.%]="c.x"
        [style.top.%]="c.y"
        [style.background]="c.color"
        [style.width.px]="c.size"
        [style.height.px]="c.size * 0.4"
        [style.transform]="'rotate(' + c.rotation + 'deg)'">
      </div>
    </div>

    <!-- Celebrate step -->
    <div class="record-card" *ngIf="recordStep === 'celebrate'">
      <div class="record-trophy">🏆</div>
      <h2 *ngIf="isNewRecord" class="record-title">¡NUEVO RÉCORD!</h2>
      <h2 *ngIf="!isNewRecord" class="record-title">¡TOP SCORE!</h2>
      <p class="record-score">{{ leaderboard.formatScore(recordGameId, recordScore) }}</p>
    </div>

    <!-- Input RUT step -->
    <div class="record-card record-input-card" *ngIf="recordStep === 'input-rut'">
      <h3>¡Felicidades! 🎉</h3>
      <p>Ingresa tu RUT para registrar tu récord</p>
      <app-on-screen-keyboard
        mode="rut"
        [value]="recordPlayerRut"
        placeholder="Ej: 12.345.678-9"
        (valueChange)="recordPlayerRut = $event"
        (enter)="onRecordRutEnter()">
      </app-on-screen-keyboard>
      <button class="btn-skip" (click)="skipRecord()">Omitir</button>
    </div>

    <!-- Input Name step -->
    <div class="record-card record-input-card" *ngIf="recordStep === 'input-name'">
      <h3>¿Cómo te llamas? 😄</h3>
      <p>Ingresa tu nombre</p>
      <app-on-screen-keyboard
        mode="text"
        [value]="recordPlayerName"
        placeholder="Tu nombre"
        [maxLength]="30"
        (valueChange)="recordPlayerName = $event"
        (enter)="onRecordNameEnter()">
      </app-on-screen-keyboard>
      <button class="btn-skip" (click)="skipRecord()">Omitir</button>
    </div>

    <!-- Saved step -->
    <div class="record-card" *ngIf="recordStep === 'saved'">
      <div class="record-trophy">✅</div>
      <h2 class="record-title">¡Registrado!</h2>
      <p>{{ recordPlayerName }}, tu récord ha sido guardado</p>
    </div>
  </div>

  <!-- ═══ SECRET MENU ═══ -->
  <div class="exit-overlay" *ngIf="showSecretMenu" (click)="closeSecretMenu()">
    <div class="exit-dialog secret-dialog" (click)="$event.stopPropagation()">

      <!-- Step 1: Password -->
      <ng-container *ngIf="!secretAuthenticated">
        <div class="secret-header">
          <span class="secret-lock">🔐</span>
          <h3>Acceso Técnico</h3>
        </div>
        <p class="secret-subtitle">Ingresa el código de acceso</p>
        <input
          type="password"
          [(ngModel)]="secretPassword"
          placeholder="Código"
          class="exit-input"
          (keyup.enter)="trySecretAuth()"
          autofocus>
        <p class="exit-error" *ngIf="secretError">Código incorrecto</p>
        <div class="exit-actions">
          <button class="btn-exit-cancel" (click)="closeSecretMenu()">Cancelar</button>
          <button class="btn-exit-confirm" (click)="trySecretAuth()">Ingresar</button>
        </div>
      </ng-container>

      <!-- Step 2: Menu options -->
      <ng-container *ngIf="secretAuthenticated">
        <div class="secret-header">
          <span class="secret-lock">⚙️</span>
          <h3>Menú Técnico</h3>
        </div>

        <div class="secret-options">
          <!-- Current client code + refresh -->
          <div class="secret-option-group" *ngIf="currentClientCode">
            <label class="secret-label">Cliente activo</label>
            <div class="secret-current-code">
              <span class="secret-code-badge">{{ currentClientCode }}</span>
              <button class="secret-refresh-btn" (click)="secretRefreshConfig()" [disabled]="secretConfigLoading">
                {{ secretConfigLoading ? 'Actualizando...' : '🔄 Actualizar configuración' }}
              </button>
            </div>
          </div>

          <!-- Change config -->
          <div class="secret-option-group">
            <label class="secret-label">{{ currentClientCode ? 'Cambiar código' : 'Código de configuración' }}</label>
            <div class="secret-config-row">
              <input
                type="text"
                [(ngModel)]="secretConfigCode"
                placeholder="Ej: ENT01"
                class="exit-input secret-code-input"
                (keyup.enter)="secretApplyConfig()">
              <button class="btn-exit-confirm" (click)="secretApplyConfig()" [disabled]="secretConfigLoading || !secretConfigCode.trim()">
                {{ secretConfigLoading ? '...' : 'Aplicar' }}
              </button>
            </div>
            <p class="secret-config-msg" *ngIf="secretConfigMessage">{{ secretConfigMessage }}</p>
          </div>

          <div class="secret-divider"></div>

          <!-- Action buttons -->
          <button class="secret-btn secret-btn-admin" (click)="secretGoToAdmin()">
            <span>📊</span> Panel de Administración
          </button>
          <button class="secret-btn secret-btn-exit" (click)="secretExitKiosk()">
            <span>🚪</span> Salir del Modo Kiosko
          </button>
          <button class="secret-btn secret-btn-close" (click)="closeApp()">
            <span>⏻</span> Cerrar Aplicación
          </button>
        </div>

        <div class="exit-actions" style="margin-top: 16px;">
          <button class="btn-exit-cancel" (click)="closeSecretMenu()">Cerrar</button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
